import { render, staticRenderFns } from "./highlightCorrectSummary.vue?vue&type=template&id=2b014889&scoped=true&"
import script from "./highlightCorrectSummary.vue?vue&type=script&lang=js&"
export * from "./highlightCorrectSummary.vue?vue&type=script&lang=js&"
import style0 from "./highlightCorrectSummary.vue?vue&type=style&index=0&id=2b014889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b014889",
  null
  
)

export default component.exports